import { useState, useEffect } from 'react';
import useLeaderboardStore from '../store/zustand/useLeaderboardStore';
import fetchLeaderboardViews from '../utils/fetchFunctions/fetchLeaderboardView';

export default function useLeaderboardViews() {
  //  @ts-ignore
  const orgID = global.me.orgID;
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [defaultView, setDefaultView] = useState<any>(null);

  const leaderboardViews: any[] | null = useLeaderboardStore(
    (state) => state.leaderboardViews
  );
  const setLeaderboardViews = useLeaderboardStore(
    (state) => state.setLeaderboardViews
  );

  useEffect(() => {
    const fetchAndStoreLeaderboardViews = async () => {
      // Only fetch if we don't have data yet
      if (leaderboardViews && leaderboardViews.length > 0) {
        return;
      }

      try {
        setIsLoading(true);
        const fetchedLeaderboardViews = await fetchLeaderboardViews();

        setLeaderboardViews(fetchedLeaderboardViews);
        setDefaultView(
          fetchedLeaderboardViews.find((view: any) => view.preferences.default)
        );
        setIsLoading(false);
      } catch (err) {
        setError(JSON.stringify(err));
      } finally {
        setIsLoading(false);
      }
    };

    fetchAndStoreLeaderboardViews();
  }, [orgID]); // Removed leaderboardViews dependency to prevent infinite loop

  return { isLoading, error, leaderboardViews, defaultView };
}
